// TEAMS Website - Venues Data
// Real venues where Claudio Andriani has performed

import { getAssetPath } from '../utils/assetPath.js';

export const venues = [
  { 
    id: 'auditorium-pittaluga',
    name: 'Auditorium Pittaluga', 
    city: 'Alessandria', 
    country: 'Italy',
    featured: true,
    website: 'https://www.conservatoriovivaldi.it/auditorium-pittaluga-comunicazione-della-direzione/',
    image: getAssetPath('venues/conservatorio-vivaldi.png')
  },
  { 
    id: 'carnegie-hall-weill',
    name: 'Carnegie Hall, Weill Recital Hall', 
    city: 'New York', 
    country: 'USA',
    featured: true,
    website: 'https://www.carnegiehall.org/About/Building-Overview/Weill-Recital-Hall',
    image: getAssetPath('venues/carnagiehall.jpg')
  },
  { 
    id: 'teatro-sociale-valenza',
    name: 'Teatro Sociale di Valenza', 
    city: 'Valenza', 
    country: 'Italy',
    featured: true,
    website: 'https://www.valenzateatro.it/',
    image: getAssetPath('venues/teatro-valenza.png')
  },
  { 
    id: 'conservatorio-catania',
    name: 'Conservatorio di Catania', 
    city: 'Catania', 
    country: 'Italy',
    featured: false,
    website: 'https://www.conservatoriocatania.it',
    image: getAssetPath('venues/bellini-catania.png')
  },
  { 
    id: 'church-san-lorenzo',
    name: 'Church of San Lorenzo', 
    city: 'Alessandria', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Church+of+San+Lorenzo&font=Playfair Display'
  },
  { 
    id: 'chiesa-del-carmine',
    name: 'Chiesa del Carmine', 
    city: 'Alessandria', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Chiesa+del+Carmine&font=Playfair Display'
  },
  { 
    id: 'chiesa-santa-maria-carmine',
    name: 'Chiesa di Santa Maria del Carmine', 
    city: 'Alessandria', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Chiesa+di+Santa+Maria+del+Carmine&font=Playfair Display'
  },
  { 
    id: 'chiesa-santa-maria-castello',
    name: 'Chiesa di Santa Maria di Castello', 
    city: 'Alessandria', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Chiesa+di+Santa+Maria+di+Castello&font=Playfair Display'
  },
  { 
    id: 'musei-strumenti-san-colombano',
    name: 'Musei degli Strumenti di San Colombano', 
    city: 'Bologna', 
    country: 'Italy',
    featured: true,
    website: 'https://genusbononiae.it/en/san-colombano-tagliavini-collection/',
    image: getAssetPath('venues/bononiae-bologna.png')
  },
  { 
    id: 'chiesa-san-domenico',
    name: 'Chiesa di San Domenico', 
    city: 'Alessandria', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Chiesa+di+San+Domenico&font=Playfair Display'
  },
  { 
    id: 'chiesa-san-pietro',
    name: 'Chiesa di San Pietro', 
    city: 'Modena', 
    country: 'Italy',
    featured: true,
    website: 'https://www.chiesasanpietromodena.it/',
    image: getAssetPath('venues/chiesa-sanpietro-modena.png')
  },
  { 
    id: 'palazzo-barolo',
    name: 'Palazzo Barolo', 
    city: 'Turin', 
    country: 'Italy',
    featured: true,
    website: 'https://palazzobarolo.it/',
    image: getAssetPath('venues/palazzo-barolo.png')
  },
  { 
    id: 'golf-club-torino',
    name: 'Golf Club Torino', 
    city: 'Turin', 
    country: 'Italy',
    featured: false,
    image: getAssetPath('venues/palazzo-barolo.png')
  },
  { 
    id: 'kouvola-finland',
    name: '', 
    city: 'Kouvola', 
    country: 'Finland',
        featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Kouvola&font=Playfair Display'
  },
  { 
    id: 'mysterium-catedreale',
    name: 'Cattedrale della Madonna della Bruna', 
    city: 'Taranto', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Cattedrale+Madonna+della+Bruna&font=Playfair Display'
  },
  { 
    id: 'karlsruhe-unknown',
    name: '', 
    city: 'Karlsruhe', 
    country: 'Germany',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Karlsruhe&font=Playfair Display'
  },
  { 
    id: 'varese-unknown',
    name: '', 
    city: 'Varese', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Varese&font=Playfair Display'
  },
  { 
    id: 'chiesa-sant-anastasio',
    name: 'Chiesa di Sant\'Anastasio', 
    city: 'Cardano al Campo', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Chiesa+di+Sant\'Anastasio&font=Playfair Display'
  },
  { 
    id: 'viola-fest-bolzano',
    name: 'unknown', 
    city: 'Bolzano', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Bolzano&font=Playfair Display'
  },
  { 
    id: 'viola-fest-siena',
    name: 'unknown', 
    city: 'Siena', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Siena&font=Playfair Display'
  },
  { 
    id: 'viola-fest-cremona',
    name: 'unknown', 
    city: 'Cremona', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Cremona&font=Playfair Display'
  },
  { 
    id: 'matera-vinconte',
    name: 'Palazzo Vinconte', 
    city: 'Matera', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Palazzo+Vinconte&font=Playfair Display'
  },
  { 
    id: 'ravenna-teatro-alighieri',
    name: 'Teatro Alighieri', 
    city: 'Ravenna', 
    country: 'Italy',
    featured: true,
    website: 'https://www.teatroalighieri.org/',
    image: getAssetPath('venues/teatro-alighieri.png')
  },
  { 
    id: 'lecce-unknown',
    name: 'unknown', 
    city: 'Lecce', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Lecce&font=Playfair Display'
  },
  { 
    id: 'besazio-unknown',
    name: 'unknown', 
    city: 'Besazio', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Besazio&font=Playfair Display'
  },
  { 
    id: 'varese-auditorium-malipiero',
    name: 'Auditorium Civico Liceo Musicale "R.Malipiero"', 
    address: 'Via Garibaldi 4',
    city: 'Varese', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Auditorium+Malipiero&font=Playfair Display'
  },
  { 
    id: 'varese-giardini-estensi',
    name: 'Giardini Estensi', 
    address: 'Varese',
    city: 'Varese', 
    country: 'Italy',
    featured: true,
    website: 'https://www.comune.varese.it/vivere_il_comune/luoghi/luogo_2.html',
    image: getAssetPath('venues/giardini-estensi-varese.jpg')
  },
  { 
    id: 'chiesa-san-giovannino',
    name: 'Chiesa di San Giovannino', 
    city: 'Alessandria', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Chiesa+di+San+Giovannino&font=Playfair Display'
  },
  { 
    id: 'monastero-santa-chiara',
    name: 'Monastero di Santa Chiara', 
    city: 'Genoa', 
    country: 'Italy',
    featured: false,
    image: 'https://placehold.co/300x200/D4A843/D4A843?text=Monastero+di+Santa+Chiara&font=Playfair Display'
  }
];

// Helper functions for venues
export const getAllVenues = () => {
  return venues;
};

export const getFeaturedVenues = () => {
  return venues.filter(venue => venue.featured);
};

export const getVenueById = (id) => {
  return venues.find(venue => venue.id === id);
};

export const getVenuesByCountry = (country) => {
  return venues.filter(venue => venue.country.toLowerCase() === country.toLowerCase());
};
